import { useEffect, useState } from 'react';

import { env } from '../../common/lib/env';
import { Strap } from '../../common/Atoms/Strap';
import { Button } from '../../common/Atoms/Button';
import { useUser } from '../hooks/useUser';

const signOffUrl = `${env.apiUrl}/signoffas`;

function formatRemaining(ms: number) {
  const totalSeconds = Math.max(0, Math.ceil(ms / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  return `${minutes}:${String(seconds).padStart(2, `0`)}`;
}

/** Banner shown while an admin is signed on as another user, counting down to the session's automatic expiry */
export function AdminOverrideStrap() {
  const { data: user } = useUser();
  const expiresAt = user?.adminOverride ? user.adminOverrideExpiresAt : null;
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!expiresAt) {
      return;
    }

    const timer = setInterval(() => setNow(Date.now()), 1000);

    return () => clearInterval(timer);
  }, [expiresAt]);

  useEffect(() => {
    // The server has dropped the override by now, sign off to land back in the admin's own org
    if (expiresAt && now >= expiresAt) {
      window.location.assign(`${signOffUrl}?expired=true`);
    }
  }, [expiresAt, now]);

  if (!user?.adminOverride) {
    return null;
  }

  return (
    <Strap
      type={ `error` }
    >
      <a href={ signOffUrl }>
        <Button color={ `none` }>
          { expiresAt
            ? `Admin Override Active · ${formatRemaining(expiresAt - now)} left · Click to sign off`
            : `Admin Override Active · Click to sign off` }
        </Button>
      </a>
    </Strap>
  );
}
